import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import { getAuthToken, getUserData, storeUserData } from '../../components/Util';
import axios from 'axios';
import api from '../../config/api';
import { images } from '../../config/image';
import { toast } from 'react-toastify';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';
class ProfileScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            userDetails: null,
            profilePic: null,
            username: null,
            selectedFile: null,
            message: "",
        }
        this.fileInputRef = React.createRef();
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);

            setTimeout(() => {
                var userData = getUserData();
                self.setState({
                    userDetails: userData.data,
                    profilePic: userData.data.profile_url,
                    username: userData.data.username
                })

                this.getUserData();
            });
        }
    }


    getUserData() {
        const self = this;
        //self.setState({ 'isLoading': true })
        axios({
            method: 'GET',
            url: api.getUserData + "?lang=" + self.state.lang,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
            }
        }).then(function (ress) {
            self.setState({
                isLoading: false,
                userDetails: ress.data.message,
                profilePic: ress.data.message.profile_url,
            })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });
            self.setState({ ProgressBar: false });
        });
    }

    // Trigger file input click when the image is clicked
    handleImageClick = () => {
        this.fileInputRef.current.click();
    };

    // Handle file selection
    handleFileChange = (event) => {
        const file = event.target.files[0];
        this.handleUpload(file);
    };

    // Handle file upload
    handleUpload(file) {

        let self = this;
        let formData = new FormData();
        formData.append("profile_pic", file);
        self.setState({ ProgressBar: true });

        axios({
            method: 'POST',
            url: api.ProfilePictureUpload,
            data: formData,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'multipart/form-data',
            }
        }).then(function (response) {
            self.setState({ 'isLoading': false })
            if (response.data.error != 200) {
                toast.error(response.data.message);
                self.setState({ ProgressBar: false });
            } else if (response.data.error === 200) {
                toast.success(response.data.message);
                self.timeoutHandle = setTimeout(() => {
                    self.getUserData();
                }, 1000);
            }

        }).catch(function (error) {
            self.setState({ 'isLoading': false });
            self.setState({ ProgressBar: false });
        })
    };

    render() {
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <Header data={{ title: strings["navProfile"] }} />

                <div className='profileScreen'>
                    <main>
                        <div className="main-button">
                            <Link to={"/purchase-history"} className="history-button">
                                <span id="purchaseHistory">{strings["purchaseHistory"]}</span>
                            </Link>
                            <Link to={"/edit-profile"} className="edit-button">
                                <span id="editButton">{strings["editButton"]}</span>
                            </Link>
                        </div>

                        <div className="info-wrap">
                            {this.state.profilePic ?
                                <img className="profile-picture" src={this.state.profilePic + "?ver=" + Math.random()} alt='' />
                                :
                                <img className="profile-picture" src={images["profile-icon"]} alt='' />
                            }
                            <div className="align-right">
                                <p className="user-id">{this.state.username}</p>

                                {/* Hidden file input */}
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={this.fileInputRef}
                                    style={{ display: "none" }}
                                    onChange={this.handleFileChange}
                                />

                                {/* Upload button */}
                                <button onClick={this.handleImageClick} className='editphoto'>
                                    {strings["editPhoto"]}
                                </button>
                            </div>
                        </div>

                        <div className="align-card">
                            <div className="profile-card">
                                <div className="card-content">
                                    <div className="left-card">
                                        <img className="card-logo" src={images["Logo"]} alt="" />
                                        <img className="card-chip" src={images["card-chip"]} alt="" />
                                        <div className="member-info">
                                            <label id="memberName">{strings["memberName"]} {this.state.userDetails && this.state.userDetails.name ? this.state.userDetails.name : ''}</label>
                                            <label id="memberIc">{strings["memberIc"]} {this.state.userDetails && this.state.userDetails.ic_no ? this.state.userDetails.ic_no : ''}</label>
                                            <label id="memberMobile">{strings["memberMobile"]} {this.state.userDetails && this.state.userDetails.mobile ? this.state.userDetails.mobile : ''}</label>
                                        </div>
                                    </div>
                                    <div className="right-card">
                                        <h2 id="pointLabel"><Link to={"/point-history"} style={{ textDecoration: "none", color: "#FFFFFF" }}>{strings["pointLabel"]}</Link></h2>
                                        <h5 style={{ alignSelf: "center", marginTop: 5, marginBottom: 10 }}>{(this.state.userDetails && this.state.userDetails.credit && this.state.userDetails.credit.point) ? this.state.userDetails.credit.point.toFixed(2) : '0.00'}</h5>
                                        <p id="memberLabel" style={{ fontSize: 10, alignSelf: "center" }}>{strings["memberLabel"]} {this.state.userDetails && this.state.userDetails.created_at ? this.state.userDetails.created_at.substring(0, 7) : '__/____'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>

                <Footer />
            </>
        );
    }
}

export default ProfileScreen;
